import { MEME_LINK_PREFIX } from 'components/shared/tiptap/memeLinkMarks'
import { isBlockedExternalNavigation } from 'lib/externalNavigationPolicy'

export type StaticAnswerAnchorAction = 'activate-meme' | 'navigate' | 'blocked'

export function getStaticAnswerAnchorAction(
    href: string | null | undefined,
    className: string | null | undefined,
    memeClass?: string,
): StaticAnswerAnchorAction | null {
    if (!href) return null
    if (isBlockedExternalNavigation(href)) return 'blocked'

    // Meme links now carry a real /meme/:text href (crawlable), so identity
    // comes from the styling class; the sentinel prefix stays recognised for
    // content stored before that change.
    const isMeme =
        href.startsWith(MEME_LINK_PREFIX) ||
        Boolean(memeClass && (className || '').includes(memeClass))

    return isMeme ? 'activate-meme' : 'navigate'
}
